<template>
  <div class="flexy">
    <h1>Tokens</h1>
    <div class="fill">
      <h2>Keys and Addresses</h2>
      <section
        class="b8 fill"
        v-if="
          !show.createkeys && s.users[s.auth.uid] && s.users[s.auth.uid].keys
        "
      >
        <div
          :class="`container update-border b4
            ${
              inputs.selectaddress[key._key]
                ? 'indicate-border bold b8'
                : 'b16 fill'
            }`"
          v-for="key in $_.orderBy(
            Object.entries(s.users[s.auth.uid].keys).map((x) => ({
              ...x[1],
              _key: x[0],
            })),
            [(x) => x.name.toLowerCase()],
            'asc'
          )"
          :key="key._key"
        >
          <span
            @click="
              $set(
                inputs.selectaddress,
                key._key,
                !inputs.selectaddress[key._key]
                  ? {
                      key: key._key,
                      chain: 'cardano',
                      address: key.address,
                      password: '',
                    }
                  : false
              );
              getaddressbalance(key);
              getaddresstxs(key.address);
            "
            class="bolder flex between align-center wrap fill update"
          >
            <row class="p4"
              ><i class="fa fa-key r4 fa-sm" /> {{ key.name }}</row
            >
            <a class="sm-font" v-if="!inputs.selectaddress[key._key]">
              <i class="l4 r4 fa update fa-chevron-down"></i>
            </a>

            <row v-else class="sm-font">
              <a
                class="white border p4"
                @click.stop="
                  $set(show.balances, key._key, !show.balances[key._key])
                "
              >
                <i class="fa fa-balance-scale r4"></i> Balances
              </a>
              <a
                class="white border p4"
                @click.stop="$set(show.txs, key._key, !show.txs[key._key])"
              >
                <i class="fa fa-link r4"></i> Transactions
              </a>
              <a
                class="white border p4"
                @click.stop="
                  getaddressbalance(key);
                  getaddresstxs(key.address);
                "
              >
                <i class="fa fa-spinner r4"></i> Refresh
              </a>
              <i class="update fa fa-chevron-up p8"></i>
            </row>
          </span>
          <div class="flex wrap between sm-font align-center p4">
            <div class="flex align-center">
              <a
                class="border r8 p4"
                @click="
                  createqr(key.address);
                  $set(show.qrs, key.address, !show.qrs[key.address]);
                "
              >
                <i class="fa fa-qrcode"></i> QR Code
              </a>
              Address: <short class="l4 update-text" :str="key.address" />
              <copy :str="key.address" />
            </div>
            <div>
              Key: <short class="indicate-text" :str="key._key" />
              <!-- <copy :str="key._key" /> -->
            </div>
            <rm
              typeconfirm
              :title="key.name"
              :fn="{
                command: 'dispatch',
                method: 'delete',
                type: 'keys',
                data: {
                  user: s.auth.uid,
                  hash: key._key,
                },
              }"
              :obj="s.users[s.auth.uid].keys"
              :name="key._key"
            />
            <img
              v-if="show.qrs[key.address] && qrs[key.address]"
              :src="qrs[key.address]"
              :alt="key.address"
            />
          </div>
          <div
            v-if="inputs.selectaddress[key._key]"
            class="flex between align-center xs-font t8 b8"
          >
            <div class="container p8 xs-font fill">
              <span
                class="flex align-center between"
                v-if="!show.transactions[key._key]"
              >
                <row w
                  >Enter key password to create tokens or transactions
                  <input
                    class=""
                    placeholder="Enter key password"
                    v-model="inputs.selectaddress[key._key].password"
                    type="password"
                  />
                </row>
                <button
                  class="update-border update-text"
                  @click="
                    verifypassword(
                      key._key,
                      key.confirmation,
                      inputs.selectaddress[key._key].password
                    )
                  "
                >
                  Verify Password
                </button>
                <span
                  v-if="show.transactions[key._key] === false"
                  class="warn-text"
                  >Please confirm your password is correct or use another
                  address to create transactions or mint tokens from.</span
                >
              </span>
              <div v-else>
                <row j="around">
                  <button
                    :class="`flexy update${!show.createtx[key.address] ? '-border update-text' : ''} p8`"
                    @click="
                      $set(show.mint, key._key, false);
                      $set(
                        show.createtx,
                        key.address,
                        !show.createtx[key.address]
                      );
                    "
                  >
                    Send Token(s)
                  </button>
                  <button
                    @click="
                      $set(show.createtx, key.address, false);
                      $set(show.mint, key._key, !show.mint[key._key]);
                    "
                    :class="`flexy update${!show.mint[key._key] ? '-border update-text' : ''} p8`"
                  >
                    Mint Token(s)
                  </button>
                  <button
                    v-if="key.txs"
                    @click="
                      $set(show.savedtxs, key._key, !show.savedtxs[key._key])
                    "
                    class="update-border p8"
                  >
                    Load Saved Txs
                  </button>
                </row>

                <fieldset
                  @value="inputs.newtoken[key._key]"
                  @change="
                    getfee(inputs.newtoken[key._key], 'ok').then((x) =>
                      $set(fees, key._key, x + 1000000)
                    )
                  "
                  class="container"
                  v-if="show.mint[key._key]"
                >
                  <div class="flex align-center between p4 border-bottom">
                    <h2>Mint Token(s)</h2>
                    <row>
                      <span>Choose token type to mint: </span>
                      <button
                        v-for="token_type in ['NFT', 'Currency']"
                        :key="token_type"
                        class="xs-font l4"
                        :class="
                          inputs.newtoken[key._key] &&
                          inputs.newtoken[key._key].type == token_type &&
                          'update-text update-border'
                        "
                        @click="
                          $set(inputs.newtoken, key._key, {
                            type: token_type,
                            meta: { fileids: [] },
                          });
                          nt = inputs.newtoken[key._key];
                        "
                      >
                        Mint {{ token_type }}
                      </button>
                    </row>
                  </div>

                  <div
                    class="flex column p4 t8"
                    :class="nt.meta && nt.meta.name && 'border-bottom b8'"
                  >
                    <div v-if="nt.meta" class="b8">
                      <h3 class="b16 update-text">
                        {{ inputs.newtoken[key._key] && inputs.newtoken[key._key].type }} Metadata
                      </h3>
                      <div>
                        <row w v-if="!show.manual">
                          <label
                            class=""
                            v-for="field in models.metadata"
                            :key="field.name"
                            :for="`nt-${field.name}`"
                          >
                            <div
                              class="b8 container m4 p4"
                              v-if="!field.type || field.type === nt.type"
                            >
                              <span>
                                <b class="r8">{{ field.name.toUpperCase() }}</b>
                                <div>{{ field.desc }}</div>
                              </span>
                              <input
                                :id="`nt-${field.name}`"
                                type="text"
                                :placeholder="`${nt.type} ${field.name}`"
                                v-model="nt.meta[field.name]"
                              />
                            </div>
                          </label>
                        </row>
                        <button
                          class="indicate-text indicate-border"
                          @click="$set(show, 'manual', !show.manual)"
                        >
                          Adjust Metadata Model
                        </button>
                        <iinput
                          formname="Metadata"
                          v-model="nt.meta"
                          v-if="show.manual"
                        />
                      </div>
                    </div>
                    <div v-if="nt.meta && nt.meta.name" class="b16">
                      <h3 class="b8 update-text">Choose File(s)</h3>
                      <media
                        media="filelist"
                        class="flexy"
                        view="compact"
                        attachid
                        tokenfile
                        select
                        v-model="nt.meta.fileids"
                      ></media>
                    </div>
                  </div>
                  <div
                    v-if="nt.meta"
                    class="flex align-center between wrap p8 b8"
                  >
                    <div v-if="fees[key._key]">
                      <div>Transaction fee: {{ fees[key._key] / 1000000 }} ADA</div>
                      <b class="indicate-text" v-if="!nt.meta.fileids || nt.meta.fileids.length == 0">No files attached</b>
                    </div>
                    <button
                      v-if="fees[key._key]"
                      :disabled="
                        !fees[key._key] ||
                        (addresses[key.address].balance && addresses[key.address].balance[0] && 
                         fees[key._key] + 1000000 > addresses[key.address].balance[0].quantity) ||
                        !nt.meta.name
                      "
                      @click="minttokens(nt, key._key)"
                      class="success p4 white lg-font"
                    >
                      Mint Token(s)
                    </button>
                    <ul
                      v-if="
                        !fees[key._key] ||
                        (addresses[key.address].balance && addresses[key.address].balance[0] && 
                         fees[key._key] + 1000000 > addresses[key.address].balance[0].quantity) ||
                        !nt.meta.name
                      "
                    >
                      <li
                        class="warn-text"
                        v-if="
                          addresses[key.address].balance && addresses[key.address].balance[0] &&
                          fees[key._key] + 1000000 >=
                          addresses[key.address].balance[0].quantity
                        "
                      >
                        Insufficient lovelace to cover fees. Please send at
                        least
                        {{
                          addresses[key.address].balance && addresses[key.address].balance[0] ?
                          fees[key._key] + 1000000 - addresses[key.address].balance[0].quantity : 0
                        }}
                        lovelace to {{ key.address }}
                        <copy :str="key.address" />
                      </li>
                      <li
                        class="warn-text"
                        v-if="
                          !nt.meta || !nt.meta.name || nt.meta.name.length == 0
                        "
                      >
                        All tokens and currencies need a name in metadata
                      </li>
                    </ul>
                  </div>
                </fieldset>

                <!-- TODO finish submit strategy.. i.e. remove tx from list -->

                <div v-if="show.savedtxs[key._key]">
                  <div
                    v-for="(savedtx, savedtxkey) in key.txs"
                    :key="savedtxkey"
                  >
                    {{ savedtx }}
                    <button
                      @click="
                        submitsavedtx(
                          savedtx.cbor,
                          inputs.newtx[key._key].passhash
                        )
                      "
                    >
                      Submit this transaction
                    </button>
                  </div>
                </div>
                <!-- TODO Check that a min ADA is available for a tx. Estimate tx fee, rounded up. -->
                <div
                  v-if="show.createtx[key.address] && inputs.newtx[key._key]"
                >
                  <div class="container">
                    <div
                      class="flex align-center update-border p4 b8 between"
                      v-if="
                        show.addoutput ||
                        inputs.newtx[key._key].outputs.length === 0
                      "
                    >
                      <input
                        :class="
                          inputs.newoutput.length !== 103 ||
                          inputs.newoutput.substring(0, 4) !== 'addr'
                            ? 'warn-border'
                            : ''
                        "
                        v-model="inputs.newoutput"
                        type="text"
                        placeholder="Enter a valid address"
                        maxlength="103"
                      />
                      <button
                        class="update-border update-text"
                        :disabled="
                          !inputs.newoutput ||
                          inputs.newoutput.length !== 103 ||
                          inputs.newoutput.substring(0, 4) !== 'addr'
                        "
                        @click="
                          !inputs.newtx[key._key].outputs
                            ? $set(inputs.newtx[key._key], 'outputs', [])
                            : null;
                          $set(
                            inputs.newtx[key._key].outputs,
                            inputs.newtx[key._key].outputs.length,
                            {
                              address: inputs.newoutput,
                              tokens: [
                                {
                                  index: 0,
                                  quantity: 2000000,
                                  unit: 'lovelace',
                                },
                              ],
                            }
                          );
                          inputs.newoutput = '';
                          show.addoutput = false;
                          settoken(
                            key,
                            inputs.newtx[key._key].outputs[
                              inputs.newtx[key._key].outputs.length - 1
                            ],
                            inputs.newtx[key._key].outputs.length - 1
                          );
                          tokenbalance(
                            inputs.newtx[key._key].outputs[
                              inputs.newtx[key._key].outputs.length - 1
                            ].tokens[0],
                            inputs.newtx[key._key].outputs,
                            key._key,
                            key.address
                          );
                        "
                      >
                        {{
                          !inputs.newoutput ||
                          inputs.newoutput.length !== 103 ||
                          inputs.newoutput.substring(0, 4) !== "addr"
                            ? "Invalid Address"
                            : "Add to transaction"
                        }}
                      </button>
                    </div>
                    <div
                      class="container p4 b4"
                      v-for="(output, outputi) in inputs.newtx[key._key]
                        .outputs"
                      :key="'newtxoutput' + key.address + outputi"
                    >
                      <div class="flex between align-center b4">
                        <div>
                          <h4>Send to:</h4>
                          <short
                            class="sm-font update-text"
                            :str="output.address"
                          />
                        </div>
                        <div
                          v-if="
                            assets &&
                            assets[key._key] &&
                            addresses[key.address].balance &&
                            Object.keys(assets[key._key]).length > 0
                          "
                        >
                          <h4>Select tokens:</h4>
                          <div
                            v-if="
                              assets &&
                              assets[key._key] &&
                              addresses[key.address].balance.length - 1 ==
                                Object.keys(assets[key._key]).length
                            "
                          >
                            <select
                              v-model="inputs.newtx[key._key].inputs[outputi]"
                              @change="settoken(key, output, outputi)"
                            >
                              <option disabled>
                                <b>Select token to send</b>
                              </option>

                              <option
                                :value="
                                  assets[key._key][token.unit] &&
                                  JSON.parse(
                                    JSON.stringify([
                                      assets[key._key][token.unit],
                                      tokenkey,
                                      assets[key._key][token.unit].hexname ||
                                        '',
                                    ])
                                  )
                                "
                                v-for="(token, tokenkey) in addresses[
                                  key.address
                                ].balance"
                                :disabled="
                                  output.tokens.find(
                                    (x) => x.index === tokenkey
                                  )
                                "
                                :key="outputi + 'token' + tokenkey"
                              >
                                <b
                                  v-if="
                                    token.unit == 'lovelace' ||
                                    assets[key._key][token.unit || token.asset]
                                  "
                                >
                                  {{
                                    (assets[key._key][
                                      token.unit || token.asset
                                    ] &&
                                      assets[key._key][
                                        token.unit || token.asset
                                      ].hexname) ||
                                    token.unit.substring(0, 9)
                                  }}
                                </b>
                              </option>
                            </select>
                            <button
                              v-if="inputs.newtx[key._key].outputs.length == 1"
                              @click="sendall(key)"
                            >
                              Send All
                            </button>
                          </div>
                        </div>
                      </div>
                      <code class="xs-font"
                        >Each output requires at least 2 ADA</code
                      >
                      <div
                        v-for="(token, tokenkey) in output.tokens"
                        :key="outputi + tokenkey"
                        class="container p4 b4"
                        :class="
                          inputs.newtx[key._key].tokenbalance[token.unit] < 0 &&
                          'warn-border'
                        "
                      >
                        <div
                          class="flex wrap between align-center"
                          v-if="
                            (addresses[key.address].balance &&
                              assets[key._key] &&
                              assets[key._key][token.unit]) ||
                            token.unit == 'lovelace'
                          "
                        >
                          <img
                            :src="
                              token.unit == 'lovelace'
                                ? 'https://icons-for-free.com/download-icon-cardano+icon-1320162855683510157_256.ico'
                                : (tokens[token.unit] &&
                                    tokens[token.unit].image) ||
                                  '/img/icons/favicon-196x196.png'
                            "
                            :alt="
                              token.unit == 'lovelace'
                                ? 'ADA (lovelace)'
                                : assets[key._key][token.unit].hexname ||
                                  token.unit
                            "
                            class="b4 thumbnail"
                          />
                          <b class="md-font">{{
                            token.unit == "lovelace"
                              ? "ADA (lovelace)"
                              : assets[key._key][token.unit].hexname ||
                                token.unit
                          }}</b>
                          <input
                            v-model="token.quantity"
                            type="number"
                            placeholder="Quantity"
                            @change="
                              tokenbalance(
                                token,
                                inputs.newtx[key._key].outputs,
                                key._key,
                                key.address
                              )
                            "
                            :min="token.unit == 'lovelace' ? 2000000 : 0"
                            :max="
                              !token.unit == 'lovelace'
                                ? (addresses[key.address].balance && addresses[key.address].balance[token.index] ?
                                    addresses[key.address].balance[token.index].quantity - fees[key._key] : 0)
                                : (addresses[key.address].balance && addresses[key.address].balance[token.index] ?
                                    addresses[key.address].balance[token.index].quantity : 0)
                            "
                          />
                          <span>
                            <span
                              class="flex"
                              v-if="
                                inputs.newtx[key._key].tokenbalance[
                                  token.unit
                                ] >= 0
                              "
                            >
                              <b>
                                of
                                {{
                                  inputs.newtx[key._key].tokenbalance[
                                    token.unit
                                  ]
                                }}
                                remaining
                              </b>
                              <code
                                class="xs-font"
                                v-if="token.unit == 'lovelace'"
                                >(Includes {{ fees[key._key] }} tx fee)</code
                              ></span
                            >
                            <label
                              @click="
                                $set(
                                  token,
                                  'quantity',
                                  +token.quantity +
                                    +inputs.newtx[key._key].tokenbalance[
                                      token.unit
                                    ]
                                );
                                tokenbalance(
                                  token,
                                  inputs.newtx[key._key].outputs,
                                  key._key,
                                  key.address
                                );
                              "
                              v-else
                              class="warn white p4"
                              >Unavailable amount [{{
                                inputs.newtx[key._key].tokenbalance[token.unit]
                              }}]</label
                            ></span
                          >

                          <button
                            v-if="
                              inputs.newtx[key._key].tokenbalance[token.unit] >
                              0
                            "
                            @click="
                              $set(
                                token,
                                'quantity',
                                +inputs.newtx[key._key].tokenbalance[
                                  token.unit
                                ] +
                                  +token.quantity -
                                  (token.unit === 'lovelace'
                                    ? fees[key._key]
                                    : 0)
                              );
                              tokenbalance(
                                token,
                                inputs.newtx[key._key].outputs,
                                key._key,
                                key.address
                              );
                            "
                          >
                            Max
                          </button>
                          <rm
                            v-if="token.unit !== 'lovelace'"
                            :obj="output.tokens"
                            :name="tokenkey"
                          />
                        </div>
                      </div>
                      <rm
                        :obj="inputs.newtx[key._key].outputs"
                        :name="outputi"
                        title="This Address"
                      />
                    </div>
                    <div class="flex column">
                      <a
                        v-if="inputs.newtx[key._key].outputs.length > 0"
                        class="update-text p4"
                        @click="show.addoutput = true"
                      >
                        Add another address
                      </a>
                    </div>
                  </div>
                  <div class="container p4 b8 t8">
                    <iinput
                      :value="inputs.newtx[key._key].metadata"
                      view="input"
                      formname="Transaction Metadata (optional)"
                    />
                    <label
                      class="flex align-center"
                      :for="key.address + 'submit'"
                      ><input
                        :id="key.address + 'submit'"
                        v-model="inputs.newtx[key._key].submit"
                        type="checkbox"
                      />Submit Transaction Immediately</label
                    >
                  </div>
                  <div class="p8 sub-container">
                    <span v-if="fees[key._key]"
                      >Transaction Fee: {{ fees[key._key] / 1000000 }} ADA</span
                    >
                    <button
                      :disabled="
                        disabled[key._key] ||
                        inputs.newtx[key._key].outputs.length === 0 ||
                        !inputs.newtx[key._key].outputs[0].tokens ||
                        inputs.newtx[key._key].outputs[0].tokens.length == 0
                      "
                      @click="
                        $set(disabled, key._key, true);
                        createtx(inputs.newtx[key._key], key._key);
                      "
                      class="fill success-border success-text lg-font"
                    >
                      Create Transaction
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="inputs.selectaddress[key._key]" class="b4">
            <div v-if="addresses[key.address]" class="flex p4 m4">
              <itable
                v-if="
                  addresses[key.address].balance &&
                  show.balances[key._key] &&
                  (assets[key._key] || utxo.unit == 'lovelace')
                "
                title="Balances"
                class="sm-font flexy"
                :order="['icon', 'unit', 'quantity']"
                :tabledata="balancedata(key)"
                :sort="'unit'"
              ></itable>

              <div class="sm-font p4" v-if="show.txs[key._key]">
                <b>Transactions</b>
                <div class="xs-font" v-if="addresses[key.address].txs.data">
                  <div
                    class="container p8 t8 flex wrap align-center between"
                    v-for="(tx, txi) in addresses[key.address].txs.data"
                    :key="txi"
                  >
                    <short :str="tx.tx_hash" />
                    <button
                      class="xs-font"
                      @click="
                        !txs[tx.tx_hash] && gettx(tx.tx_hash);
                        $set(show.tx, tx.tx_hash, !show.tx[tx.tx_hash]);
                      "
                    >
                      Details
                    </button>
                    <div
                      v-if="
                        show.tx[tx.tx_hash] &&
                        txs[tx.tx_hash] &&
                        txs[tx.tx_hash].output_amount
                      "
                    >
                      <state :statedata="txs[tx.tx_hash]" list="true" />
                      <h4>Tx Outputs</h4>
                      <div
                        class="container p8 flex wrap align-center"
                        :style="`order:${
                          output.unit === 'lovelace' ? 0 : outputi + 1
                        }`"
                        v-for="(output, outputi) in txs[tx.tx_hash]
                          .output_amount"
                        :key="outputi"
                      >
                        <div>
                          <span class="xs-font update-text r4">QTY</span
                          ><b class="r8">{{ output.quantity }}</b>
                        </div>
                        <div>
                          <span
                            class="sm-font"
                            @click="
                              show.assets[key._key] =
                                show.assets[key._key] || {};
                              output.unit !== 'lovelace'
                                ? assets[key._key][output.unit]
                                  ? $set(
                                      show.assets[key._key],
                                      output.unit,
                                      !show.assets[key._key][output.unit]
                                    )
                                  : getasset(output.unit, key._key)
                                : null;
                            "
                            ><span class="xs-font update-text r4">TYPE</span
                            >{{ output.unit }}</span
                          >
                        </div>
                        <div
                          v-if="
                            assets[key._key] &&
                            assets[key._key][output.unit] &&
                            show.assets[key._key][output.unit]
                          "
                        >
                          <div class="sub-container p8">
                            <h2 class="b8">
                              {{ assets[key._key][output.unit].hexname }}
                            </h2>
                            <img
                              :src="
                                output.unit === 'lovelace'
                                  ? 'https://icons-for-free.com/download-icon-cardano+icon-1320162855683510157_256.ico'
                                  : tokens[output.unit].image ||
                                    '/img/icons/favicon-196x196.png'
                              "
                              :alt="
                                assets[key._key][output.unit].hexname ||
                                output.unit
                              "
                            />
                          </div>
                          <state
                            list="true"
                            :statedata="assets[key._key][output.unit]"
                          ></state>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="warn-text" v-else>
                  {{ addresses[key.address].txs.data }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div class="p4">
        <button
          class="success-text success-border xs-font"
          @click="show.newaddress = !show.newaddress"
        >
          <i class="fa fa-plus r4"></i> Create Address
        </button>

        <div v-if="show.newaddress" class="flex wrap">
          <div class="flex column p8">
            <p>1. Choose chain</p>
            <b
              :class="inputs.newaddress.chain == chain ? 'update' : ''"
              @click="$set(inputs.newaddress, 'chain', chain)"
              :key="chain"
              v-for="chain in ['cardano', 'bitcoin', 'ethereum']"
              :value="chain"
              >{{ chain.toUpperCase() }}</b
            >
          </div>
          <div v-if="inputs.newaddress.chain" class="flex column p8">
            <p>2. Create Keys</p>
            <div class="flex column">
              <b>Key Name</b>
              <input
                type="text"
                v-model="inputs.newaddress.name"
                placeholder="Give a name for this keypair / address"
              />
              <b>Key Password</b>

              <input
                type="password"
                v-model="inputs.newaddress.password"
                placeholder="Enter a password"
              />
              <input
                :class="
                  inputs.newaddress.password !==
                  inputs.newaddress.confirmpassword
                    ? 'warn-border'
                    : ''
                "
                type="password"
                v-model="inputs.newaddress.confirmpassword"
                placeholder="Confirm password"
              />
              <label
                class="warn"
                v-if="
                  inputs.newaddress.password !==
                  inputs.newaddress.confirmpassword
                "
                >Passwords must match</label
              >
            </div>
            <button
              @click="getaddress(inputs.newaddress)"
              class="success sm-font p8 t8"
              :disabled="
                !inputs.newaddress.password ||
                (show.createkeys &&
                  inputs.newaddress.password !==
                    inputs.newaddress.confirmpassword)
              "
            >
              Create Keys and Address
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="container p8 xs-font">
      <row j="between">
        <h2>XMBL tokens</h2>
        <button class="update-text update-border" @click="gettoken()">
          <i class="fa fa-coin r4"></i> Fetch tokens
        </button>
      </row>
      <div v-if="tokens && s.tokens">
        Count: {{ Object.keys(s.tokens).length }}
        <state :statedata="s.tokens" list="list" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "tokens",
  data() {
    return {
      assets: {},
      addresses: {},
      cloudurl: this.$store.state.cloudurl,
      disabled: {},
      tokens: {},
      fees: {},
      inputs: {
        selectaddress: {},
        newaddress: {
          chain: "",
          password: "",
          confirmpassword: "",
          key: "",
        },
        newoutput: "",
        newtx: {},
        newtoken: {},
      },
      models: {
        metadata: [
          { desc: "", name: "name" },
          { desc: "Who made this content", name: "artist", type: "NFT" },
          {
            desc: "How many tokens will be minted",
            name: "supply",
            type: "Currency",
          },
          {
            desc: "The name of the collection this token belongs to",
            name: "collection",
            type: "NFT",
          },
          {
            desc: "If this token is dynamic, provide the contract to be called when minting or using",
            name: "contract_id",
          },
          { desc: "Who is responsible for minting", name: "creator" },
          { desc: "", name: "discord" },
          { desc: "", name: "rarity", type: "NFT" },
          { desc: "", name: "set", type: "NFT" },
          { desc: "", name: "twitter" },
          { desc: "", name: "copyright" },
          { desc: "", name: "ticker" },
        ],
      },
      nt: {}, // variable to hold new token data
      show: {
        assets: {},
        balances: {},
        files: {},
        newaddress: false,
        createkeys: false,
        createtx: {},
        keypassword: {},
        manual: false,
        mint: {},
        confirmedpasswords: [],
        qrs: {},
        transactions: {},
        tx: {},
        txs: {},
        addoutput: false,
        savedtxs: {},
        search: {},
      },
      test: {
        keys: "",
        address: "",
      },
      txs: {},
      qrs: {},
      s: this.$store.state,
      d: this.$store.dispatch,
      m: this.$store.commit,
    };
  },
  methods: {
    balancedata(key) {
      return this.addresses[key.address].balance.map((x) => ({
        unit:
          (this.assets[key._key][x.unit] &&
            this.assets[key._key][x.unit].hexname) ||
          "lovelace",
        quantity: x.quantity,
        icon:
          x.unit == "lovelace"
            ? "https://icons-for-free.com/download-icon-cardano+icon-1320162855683510157_256.ico"
            : (this.tokens[x.unit] && this.tokens[x.unit].image) ||
              "/img/icons/favicon-196x196.png",
      }));
    },
    settoken(key, output, outputi) {
      console.log("setting token to address in tx, ", { key, output, outputi });
      let inputs = this.inputs;
      let addresses = this.addresses;
      let $set = this.$set;
      console.log({ inputs });
      !inputs.newtx[key._key] ||
      !inputs.newtx[key._key].inputs ||
      !inputs.newtx[key._key].inputs[outputi] ||
      !inputs.newtx[key._key].inputs[outputi][0]
        ? null
        : ($set(
            inputs.newtx[key._key].inputs[outputi][0],
            "index",
            inputs.newtx[key._key].inputs[outputi][1]
          ),
          inputs.newtx[key._key].inputs[outputi][2] &&
            $set(
              inputs.newtx[key._key].inputs[outputi][0],
              "name",
              inputs.newtx[key._key].inputs[outputi][2]
            ),
          $set(
            inputs.newtx[key._key].inputs[outputi][0],
            "quantity",
            inputs.newtx[key._key].tokenbalance[
              inputs.newtx[key._key].inputs[outputi][0].unit
            ]
              ? +inputs.newtx[key._key].tokenbalance[
                  inputs.newtx[key._key].inputs[outputi][0].unit
                ]
              : +addresses[key.address].balance[
                  inputs.newtx[key._key].inputs[outputi][1]
                ].quantity
          ),
          console.log(
            "inputs.newtx[key._key].inputs[outputi][0]",
            inputs.newtx[key._key].inputs[outputi][0]
          ),
          output.tokens.push(inputs.newtx[key._key].inputs[outputi][0]),
          this.tokenbalance(
            inputs.newtx[key._key].inputs[outputi][0],
            inputs.newtx[key._key].outputs,
            key._key,
            key.address
          ).then(() => {
            $set(inputs.newtx[key._key].inputs, outputi, []);
            this.d("crypto", {
              type: "fee",
              data: {
                tx: {
                  newtx: inputs.newtx[key._key],
                  inputs: addresses[key.address].balance,
                },
              },
            });
          }));
    },
    async minttokens(tx, key) {
      return await this.d("crypto", {
        type: "mint",
        data: { tx, key, inputs: this.inputs },
      }).then((x) => {
        console.log({ x });
        if (!x) return;
        if (x.data && x.data.exitCode == 1)
          return this.$store.commit("point", {
            header: "Minting Unsuccessful",
            text: x,
          });
        this.$store.commit("point", { header: "Minting Success", text: x });
        this.$set(this.disabled, key, false);
      });
    },
    async submitsavedtx(cbor, passhash) {
      return await this.d("api", {
        address: this.cloudurl + "submitsignedtx",
        verb: "post",
        data: { cbor, passhash },
      }).then((x) => {
        console.log({ x });
      });
    },
    async createtx(tx, key) {
      tx.fee = this.fees[key];
      this.d("crypto", {
        type: "tx",
        data: { tx, key, inputs: this.inputs },
      }).then((x) => {
        console.log({ x });
        this.$set(this.disabled, key, false);
        if (tx.submit) {
          this.$set(this.inputs.newtx, key, {
            passhash: tx.passhash,
            outputs: [],
            inputs: [],
            metadata: {},
            tokenbalance: {},
            submit: false,
          });
        } else {
          this.$set(
            this.show.createtx,
            tx.address,
            !this.show.createtx[tx.address]
          );
        }
      });
    },
    async verifypassword(keyid, key, password) {
      return await this.d("util", {
        type: "hash",
        body: password,
        count: 2,
      }).then((h) => {
        if (h !== key) return this.$set(this.show.transactions, keyid, false);
        this.d("util", { type: "hash", body: password, count: 1 }).then(
          (h1) => {
            this.$set(this.inputs.newtx, keyid, {
              passhash: h1,
              outputs: [],
              inputs: [],
              metadata: {},
              tokenbalance: {},
              submit: false,
            });
            this.$set(this.show.transactions, keyid, key === h);
            return h1;
          }
        );
      });
    },
    async getasset(asset, key, index) {
      if (asset == "lovelace") return;
      return await this.d("api", {
        address: this.cloudurl + "getasset?asset=" + asset,
        verb: "get",
      }).then(async (x) => {
        let errcount = 0;
        if (errcount < 5 && x.data.error) {
          errcount = errcount++;
          return this.getasset(asset, key, index);
        } else if (x.data.error) {
          return console.error({ error: x.data.error });
        }
        await this.d("util", { type: "hex2str", hex: x.data.asset_name }).then(
          (y) => {
            x.data.hexname = y;
            x.data.index = index;
            x.data.unit = x.data.asset;
            if (!this.assets[key]) this.$set(this.assets, key, {});
            if (!this.tokens[x.data.asset])
              this.$set(this.tokens, x.data.asset, {});
            if (x.data.onchain_metadata) {
              if (x.data.onchain_metadata.ipfs)
                this.$set(
                  this.tokens[x.data.asset],
                  "image",
                  "https://ipfs.io/ipfs/" + x.data.onchain_metadata.ipfs
                );
              else if (
                x.data.onchain_metadata.files &&
                x.data.onchain_metadata.files[0] &&
                x.data.onchain_metadata.files[0].src &&
                x.data.onchain_metadata.files[0].src != "ipfs://undefined"
              )
                this.$set(
                  this.tokens[x.data.asset],
                  "image",
                  "https://ipfs.io/ipfs/" +
                    x.data.onchain_metadata.files[0].src.split("ipfs://")[1]
                );
              else if (
                x.data.onchain_metadata.image &&
                x.data.onchain_metadata.image !== "ipfs://undefined"
              )
                this.$set(
                  this.tokens[x.data.asset],
                  "image",
                  "https://ipfs.io/ipfs/" +
                    x.data.onchain_metadata.image.split("ipfs://")[1]
                );
              else
                this.$set(
                  this.tokens[x.data.asset],
                  "image",
                  this.s.app.basics.logo.length > 0
                    ? this.s.app.basics.logo
                    : "/img/icons/favicon-196x196.png"
                );
            } else {
              this.$set(
                this.tokens[x.data.asset],
                "image",
                this.s.app.basics.logo.length > 0
                  ? this.s.app.basics.logo
                  : "/img/icons/favicon-196x196.png"
              );
            }
            if (!this.show.assets[key]) this.$set(this.show.assets, key, {});
            this.$set(this.assets[key], asset, x.data);
            this.$set(this.show.assets[key], asset, true);
          }
        );
      });
    },
    async getaddressbalance(key) {
      let address = key.address;
      if (!this.addresses[address]) {
        this.$set(this.addresses, address, {});
      }
      return await this.d("api", {
        address: `${this.cloudurl}getaddressbalance?address=${address}`,
        verb: "get",
      }).then((x) => {
        console.log("balance", { x });
        this.$set(this.assets, key._key, {});
        if (typeof x.data == "string") return;
        if (x.data && x.data.amount && Array.isArray(x.data.amount)) {
          x.data.amount.forEach(
            (y, yi) => this.getasset(y.unit, key._key, yi).then((z) => z)
            // console.log(y.unit, this.getasset(y.unit).then((z) => z))
          );
          this.$set(this.addresses[address], "balance", x.data.amount);
        } else {
          console.error("Invalid balance data structure:", x.data);
          this.$set(this.addresses[address], "balance", []);
        }
      }).catch((error) => {
        console.error("Error fetching balance:", error);
        this.$set(this.addresses[address], "balance", []);
      });
    },
    async gettx(tx) {
      return await this.d("api", {
        address: this.cloudurl + "gettx?tx=" + tx,
        verb: "get",
      }).then((x) => this.$set(this.txs, tx, x.data));
    },
    async getaddresstxs(address) {
      if (!this.addresses[address]) {
        this.$set(this.addresses, address, {});
      }
      return await this.d("api", {
        address: this.cloudurl + "getaddresstxs?address=" + address,
        verb: "get",
      }).then((x) => {
        if (x && x.data) {
          this.$set(this.addresses[address], "txs", x);
        } else {
          console.error("Invalid transaction data structure:", x);
          this.$set(this.addresses[address], "txs", { data: [] });
        }
      }).catch((error) => {
        console.error("Error fetching transactions:", error);
        this.$set(this.addresses[address], "txs", { data: [] });
      });
    },
    async gettoken() {
      await this.d("t", { gettoken: true }).then(() => {
        // console.log({ d });
        this.$set(this, "tokens", this.s.tokens);
      });
    },
    async getaddress(newaddress) {
      // console.log({ newaddress });
      // this.d('crypto', {type: 'fee', data: 'some string'})
      if (
        (this.show.createkeys &&
          newaddress.password !== newaddress.confirmpassword) ||
        (!this.show.createkeys && !newaddress.password)
      )
        return alert("Passwords must match");
      this.d("util", { body: newaddress.password, type: "hash" }).then(
        (ret) => {
          // console.log({ ret });
          return this.d("crypto", {
            type: "address",
            data: {
              chain: newaddress.chain,
              passhash: ret,
              key: newaddress.key || null,
            },
          }).then(async (getaddressreturn) => {
            // console.log({ getaddressreturn });
            let userkeys = this.s.user[this.s.auth.uid].keys || {};
            if (newaddress.key) {
              this.$set(
                userkeys[newaddress.key],
                "address",
                getaddressreturn.data.address
              );
            } else {
              this.$set(userkeys, getaddressreturn.data.verification, {
                name: newaddress.name,
                address: getaddressreturn.data.address,
                confirmation: await this.d("util", {
                  body: ret,
                  type: "hash",
                  count: 1,
                }).then((h) => h),
              });
            }
            this.$set(this.s.user[this.s.auth.uid], "keys", userkeys);
            this.d("update", { type: "keys", keys: userkeys });
            return this.$set(this.show, "newaddress", false);
          });
        }
      );
    },
    createqr(address) {
      return this.d("util", { type: "qr", obj: address }).then((x) =>
        this.$set(this.qrs, address, x)
      );
    },
    async getfee(tx, inputs) {
      return await this.d("crypto", {
        type: "fee",
        data: {
          tx: { tx, inputs },
        },
      }).then((x) => x);
    },
    async tokenbalance(token, inputs, key, address) {
      console.log({ token, inputs, key, address });
      let total = inputs
        .filter((x) => x.tokens.find((y) => y.unit === token.unit))
        .reduce((acc, input) => {
          return (
            +acc + +input.tokens.find((x) => x.unit === token.unit).quantity
          );
        }, 0);
      let balance = this.addresses[address].balance && this.addresses[address].balance[token.index] ?
        +this.addresses[address].balance[token.index].quantity - total : 0;
      console.log({ total, balance });
      this.$set(this.inputs.newtx[key].tokenbalance, token.unit, balance);
      return this.inputs.newtx[key].tokenbalance[token.unit];
    },
    async sendall(k) {
      const key = k._key,
        address = k.address;
      let outputs = JSON.parse(
        JSON.stringify(this.addresses[address].balance)
      ).map((token, tokeni) => {
        this.$set(this.inputs.newtx[key].tokenbalance, token.unit, 0);
        return { ...token, index: tokeni };
      });

      this.$set(this.inputs.newtx[key].outputs[0], "tokens", outputs);
      outputs.map((x) =>
        this.tokenbalance(x, this.inputs.newtx[key].outputs, key, address)
      );
      this.fees[key] = await this.getfee(
        [this.inputs.newtx[key].outputs, this.inputs.newtx[key].metadata],
        outputs
      ).then((x) => x);
      console.log(this.fees[key]);

      if (this.addresses[address].balance && this.addresses[address].balance[0]) {
        this.$set(
          this.inputs.newtx[key].outputs[0].tokens[0],
          "quantity",
          +this.addresses[address].balance[0].quantity - this.fees[key]
        );
      }

      this.tokenbalance(
        outputs[0],
        this.inputs.newtx[key].outputs,
        key,
        address
      );
    },
  },
  watch: {
    "inputs.newtx": {
      handler(o, n) {
        Object.keys(n).map((x) => {
          !this.fees[x] ? (this.fees[x] = 200000) : null;
          let addressamounts =
            this.addresses[this.inputs.selectaddress[x].address].balance;
          let meta = n[x].metadata;
          let outputs = n[x].outputs;
          this.getfee({ meta, outputs }, addressamounts).then((y) => {
            if (this.fees[x] && Math.abs(y - this.fees[x]) > 10000) {
              this.fees[x] = y >= 200000 ? y : 200000;
              this.$set(this.fees, x, this.fees[x]);
            }
          });
        });
      },
      deep: true,
    },
  },
};
</script>